/* __next_internal_client_entry_do_not_use__ StakingTimeSelection auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStore } from "../../StoreProvider";
import styles from "./index.module.scss";
import { formatDecimal, secondsTurnDay } from "../../utils";
import BigNumber from "bignumber.js";
const StakingTimeSelection = (param)=>{
    let { className, list } = param;
    const t = useTranslations("");
    const { amountValue } = useStore();
    const { timeType, setTimeType } = useStore();
    const viewList = useMemo(()=>{
        return list.map((item)=>{
            return {
                ...item,
                title: item.flexible_staking ? t("stakingCurrent") : "".concat(secondsTurnDay(item.duration)).concat(t("Newer_day")),
                describe: t("bgbStakingExpectedRevenueDay", {
                    amount: formatDecimal(BigNumber(amountValue).times(item.yearRate).dividedBy(100).dividedBy(365).dp(8).toFixed())
                }),
                apy: item.yearRate,
                value: item.pool_id
            };
        });
    }, [
        t,
        list,
        amountValue
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "".concat(className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center mb-10px",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-500 text-[var(--text-7)] text-15px mr-10px",
                        children: t("stakingTime")
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "p0.5 flex items-center justify-center relative",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "bg-[var(--primary)] rounded-1 absolute w-full h-full opacity-12"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[var(--primary)] font-500 text-11px leading-14px",
                                children: t("dailyInterestPayment")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "flex flex-col gap4",
                children: viewList.map((item)=>{
                    return /*#__PURE__*/ _jsxs("li", {
                        className: "".concat(timeType === item.value ? styles.select : "", " ").concat(styles.timeBox),
                        onClick: ()=>setTimeType(item.value),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.leftBox,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.viewBox
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-[var(--text-7)] font-600 text-16px leading-20px mb1",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-[var(--text-1)] text-13px leading-20px opacity-80",
                                                children: item.describe
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "".concat(styles.apy, " flex items-center"),
                                children: [
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-[var(--primary)] text-18px",
                                        children: [
                                            item.apy,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ml1 text-[var(--text-4)]",
                                        children: "APY"
                                    })
                                ]
                            })
                        ]
                    }, item.apy);
                })
            })
        ]
    });
};
export { StakingTimeSelection };
